import { ApiClient } from '../config';
import type { Module } from '../../types/domain';

export interface ModuleService {
  getModules(): Promise<Module[]>;
}

export class ModuleServiceImpl implements ModuleService {
  private apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient;
  }

  async getModules(): Promise<Module[]> {
    try {
      return await this.apiClient.get<Module[]>('/api/v1/modules');
    } catch (error) {
      console.error('[ModuleService] Error fetching modules:', error);
      throw error;
    }
  }
}

export const moduleService = new ModuleServiceImpl(new ApiClient());
